import { render, staticRenderFns } from "./admin_debug.vue?vue&type=template&id=23ecec6e&scoped=true"
import script from "./admin_debug.vue?vue&type=script&lang=js"
export * from "./admin_debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ecec6e",
  null
  
)

export default component.exports